"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'db.operation.create': 'Crea',
    'db.operation.update': 'Aggiorna',
    'db.operation.delete': 'Elimina',
    'db.operation.upsert': 'Upsert',
    'db.operation.createMany': 'Crea molti',
    'db.operation.updateMany': 'Aggiorna molti',
    'db.operation.deleteMany': 'Elimina molti',
    'db.operation.findFirst': 'Trova primo',
    'db.operation.findMany': 'Trova molti',
    'db.operation.findUnique': 'Trova unico',
    'db.operation.count': 'Conta',
    'db.operation.aggregate': 'Aggrega',
    'db.operation.groupBy': 'Raggruppa per',
};
